import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../configuration/setup/store";
import { DashboardPageState } from "./dashboardPageTypes";
import { DialogState } from "../alerts/alertsPageSlideTypes";

const STORAGE_KEY = "maila-ui-preference";
const isNewUi = localStorage.getItem(STORAGE_KEY) === "true";

const initialState: DashboardPageState = {
	paramsFilter: isNewUi ? [] : ["not_alerts"],
	reloadPage: false,
	openDialogDigitalSchedule: {
		open: false,
		chassis: "",
		vehicle: "",
		vehicleId: "",
	},
	openDialogNotifications: {
		open: false,
		row: {},
	},
};

const dashboardPageSlice = createSlice({
	name: "dashboardPage",
	initialState,
	reducers: {
		triggerReloadPage: (state) => {
			state.reloadPage = !state.reloadPage;
		},
		setParamsFilter: (state, action: PayloadAction<string[]>) => {
			state.paramsFilter = action.payload;
		},
		setOpenDialogDigitalSchedule: (state, action: PayloadAction<any>) => {
			state.openDialogDigitalSchedule = action.payload;
		},
		setOpenDialogNotifications: (state, action: PayloadAction<DialogState>) => {
			state.openDialogNotifications = action.payload;
		},
	},
});

export const { setParamsFilter, setOpenDialogDigitalSchedule, setOpenDialogNotifications } = dashboardPageSlice.actions;
export const getFilterType = (state: RootState) => state.pageDashboard.paramsFilter;
export const getDashboardPageData = (state: RootState) => state.pageDashboard;
export const getDialogDashboard = (state: RootState) => state.pageDashboard.openDialogNotifications;
export default dashboardPageSlice.reducer;
